var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.submit()}}},[_vm._v("立即发布")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }